import React from 'react';
import classNames from 'classnames/bind';
import styles from './Stepper.module.scss';

const cx = classNames.bind(styles);

function Stepper({ stepList, current, withoutNumber = false, style = null }) {
	const cols = stepList.length;
	const stepItem = stepList.map((item, index) => {
		const key = `step${index}`;
		const text = withoutNumber ? item : `${index + 1}. ${item}`;
		return (
			<li
				key={key}
				className={cx(`col${cols}`, { active: index < current })}
			>
				{text}
			</li>
		);
	});

	return (
		<ol
			className={cx('stepper')}
			style={style}
		>
			{stepItem}
		</ol>
	);
}

export default Stepper;
